import produce from 'immer'
import { assign, stubFalse } from 'lodash'

import { createSelectOptions } from '../../helpers'
import { COMMON_FETCH_DIETS } from '../action-types'
import { DIETS_INITIAL_STATE } from '../initial-states'

const dietsReducer = (state = DIETS_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_DIETS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_DIETS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.diets,
          options: createSelectOptions(
            action.payload.data.diets,
            'name',
            'id',
            stubFalse,
            ['excludedIngredients'],
          ),
        }),
      )

    case COMMON_FETCH_DIETS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_DIETS.CLEANUP:
      return { ...DIETS_INITIAL_STATE }

    default:
      return state
  }
}

export default dietsReducer
